const { Vue } = window;
window.workWithUs = new Vue({
  el: '#services-promo',
  data: {
    isExpanded: false,
    isVisible: true
  },
  created() {
    if (sessionStorage.getItem('showPromo') === 'false') {
      this.isVisible = false;
    }
  },
  methods: {
    toggleExpansion() {
      this.isExpanded = !this.isExpanded;
    },
    closePromo() {
      this.isVisible = false;
      sessionStorage.setItem('showPromo', false);
    }
  }
});
